// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import {Analytics} from '../../../../services/analytics';
import {CreateTriggerDrawer} from '../CreateTriggerDrawer/CreateTriggerDrawer';
import {BaseTriggerDrawerInit} from '../CreateTriggerDrawer/EventStore';
import {DeleteTriggerModal} from '../DeleteTriggerModal';
import {isViewTriggerDisabled} from './TriggerName';
import {Trigger} from './utilTypes';
import {ViewTriggerDrawer} from './ViewTriggerDrawer';

enum TriggerActionModals {
  DeleteTrigger = 'DELETE_TRIGGER',
  ViewTrigger = 'VIEW_TRIGGER',
  EditTrigger = 'EDIT_TRIGGER',
}

type TriggerActionProps = {
  trigger: Trigger;
  refetchProjectTriggers: () => Promise<any>;
  refetchCollectionTriggers?: () => Promise<any>;
  baseTriggerDrawerInit: BaseTriggerDrawerInit;
  readOnly: boolean;
};

export const TriggerActions = ({
  trigger,
  refetchCollectionTriggers,
  refetchProjectTriggers,
  baseTriggerDrawerInit,
  readOnly,
}: TriggerActionProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [triggerModal, setTriggerModal] = useState<TriggerActionModals>();
  const history = useHistory();

  const handleViewHistory = () => {
    Analytics.track('Automation Execution History', {
      type: 'click_history_tab',
      location: history.location.pathname,
      triggerId: trigger.id,
    });

    // Navigate to the automations history tab with trigger filter
    const currentPath = history.location.pathname;
    const urlParams = new URLSearchParams({
      tab: 'history',
      triggerId: trigger.id,
    });

    history.push({
      pathname: currentPath,
      search: `?${urlParams.toString()}`,
    });
  };

  return (
    <Tailwind style={{height: '100%', width: '100%'}}>
      <div className="flex h-full flex-col items-end justify-center">
        <div className="mr-8 flex h-full items-center justify-end">
          <DropdownMenu.Root open={isMenuOpen} onOpenChange={setIsMenuOpen}>
            <DropdownMenu.Trigger>
              <Button
                size="medium"
                variant="ghost"
                icon="overflow-horizontal"
                active={isMenuOpen}
              />
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
              <DropdownMenu.Content align="end">
                <DropdownMenu.Group>
                  <DropdownMenu.Item
                    onClick={() => {
                      setIsModalOpen(true);
                      setTriggerModal(TriggerActionModals.ViewTrigger);
                    }}
                    disabled={isViewTriggerDisabled(trigger)}>
                    <Icon name="list" />
                    View details
                  </DropdownMenu.Item>
                  <DropdownMenu.Item
                    onClick={() => {
                      setIsModalOpen(true);
                      setTriggerModal(TriggerActionModals.EditTrigger);
                    }}
                    disabled={readOnly}>
                    <Icon name="pencil-edit" />
                    Edit automation
                  </DropdownMenu.Item>
                  <DropdownMenu.Item onClick={handleViewHistory}>
                    <Icon name="history" />
                    View history
                  </DropdownMenu.Item>
                </DropdownMenu.Group>
                <DropdownMenu.Separator />
                <DropdownMenu.Item
                  onClick={() => {
                    setIsModalOpen(true);
                    setTriggerModal(TriggerActionModals.DeleteTrigger);
                  }}
                  disabled={readOnly}>
                  <Icon name="delete" />
                  Delete automation
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
          <DeleteTriggerModal
            open={
              isModalOpen && triggerModal === TriggerActionModals.DeleteTrigger
            }
            onClose={() => {
              setTriggerModal(undefined);
              setIsModalOpen(false);
            }}
            triggerID={trigger.id}
            triggerName={trigger.name}
            afterDelete={async () => {
              await refetchProjectTriggers();
              if (refetchCollectionTriggers) {
                await refetchCollectionTriggers();
              }
            }}
          />
          <ViewTriggerDrawer
            open={
              isModalOpen && triggerModal === TriggerActionModals.ViewTrigger
            }
            closeDrawer={() => {
              setTriggerModal(undefined);
              setIsModalOpen(false);
            }}
            trigger={trigger}
          />
          <CreateTriggerDrawer
            open={
              isModalOpen && triggerModal === TriggerActionModals.EditTrigger
            }
            closeDrawer={() => {
              setTriggerModal(undefined);
              setIsModalOpen(false);
            }}
            createTriggerDrawerInit={{
              ...baseTriggerDrawerInit,
              isUpdating: true,
              trigger,
            }}
            refetchProjectTriggers={refetchProjectTriggers}
            refetchCollectionTriggers={refetchCollectionTriggers}
          />
        </div>
      </div>
    </Tailwind>
  );
};
